import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2250. Slack連携設定削除
 * [DELETE] /workspaces/:identifier/slack_setting
 */
type Props = {
  identifier: string;
};

const destroySlackSetting = (props: Props) => {
  return axios.delete(`/api/workspaces/${props.identifier}/slack_setting`);
};

export const useDestroySlackSetting = () => {
  return useMutation({
    mutationFn: destroySlackSetting,
  });
};
